import React from "react";
import { Provider } from "react-redux";
import "regenerator-runtime/runtime";
// import { BrowserRouter } from 'react-router-dom'

import createReduxStore from "./src/reducers";

export const wrapRootElement = ({ element }) => {
	const store = createReduxStore();

	return (
      <Provider store={store}>
        {/* <BrowserRouter> */}
            {element}
        {/* </BrowserRouter> */}
		  </Provider>
    );
}
